import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import moment from 'moment';
import * as React from 'react';
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  TextField,
  Chip,
  Collapse,
  TableHead
} from '@mui/material';
import { ExpandMore, ExpandLess, Send } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appApi } from 'src/apiUtils/AppApi';
import { url } from 'src/apiUtils/apiPath';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import config from '../AppConfig'

const TABLE_HEAD = [
  { id: 'user', label: 'User Name', alignHeader: false },
  { id: 'date', label: 'Date', alignHeader: false },
  { id: 'slot', label: 'Slot Time', alignHeader: false },
  { id: 'studio_user', label: `${config.appUserType}`, alignHeader: false },
  { id: 'status', label: 'Status', alignHeader: false },
  { id: 'actions', label: 'Actions', alignHeader: false },
];



export default function BookingPage() {

  const [open, setOpen] = useState(false);

  const [rowClickId, setRowClickId] = useState();

  const [page, setPage] = useState(0);

  const [isLoading, setIsloading] = useState(false)

  const [order, setOrder] = useState('asc');

  const [bookingList, setBookingList] = useState([]);

  const [orderBy, setOrderBy] = useState('user.parnter_detail.user_name');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [userProfileDetail, setUserProfileDetail] = useState({
    "userPhone": "",
    "userName": "",
    "userId": "",
    "expertName": "",
    "description": "",
    "title": "",
    "avatarUrl": "",
    "file": "",
    "expertSkillLevel": "",
    "availableForSession": "",
    "language": [],


  })

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };


  const [addEdit, setaddEdit] = useState(false)
  const [isEdit, setisEdit] = useState(false)

  const [userType, setUserType] = useState(1)

  const [greetFile, setGreetFile] = useState([])
  useEffect(() => {
    handleBookinglist();
  }, [])

  const handleBookinglist = () => {
    appApi(`${url.BOOKING_USER_EXPERT_LIST}`, "POST", {}).then((result) => {
      console.log(result)
      if (result.data.length > 0) {
        setBookingList(result.data)
      } else {
        setBookingList([])
      }

    })
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sendUserMessage = (id, phone, message) => {
    console.log('greet file', greetFile)
    const formData = new FormData();
    formData.append('booking_id', id);
    formData.append('message', message);
    formData.append('phone', phone);
    const file = greetFile.find(e => e._id === id);
    if (file !== '' && file !== null && file !== undefined && phone !== '' && phone !== null && phone !== undefined) {
      formData.append('file', file.file);
      appApi(url.SEND_BOOKING_MESSAGE, "POST", {}, formData)
        .then((result) => {
          notifySuccess("Greet Send Successfully")
          handleBookinglist()
        })

    } else {
      alert(phone)
      notify((phone === '' && phone === null && phone === undefined) ? "Phone Number is empty" : "Please upload the file")
    }
  }

  const notify = (msg) => toast.error(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );

  const notifySuccess = (msg) => toast.success(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - bookingList.length) : 0;

  return (
    <>
      <Helmet>
        <title> Booking Management  </title>
      </Helmet>

      < Container maxWidth="xl">
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ paddingTop: 1 }}>
              <Typography variant="h4" gutterBottom>
                Booking Management
              </Typography>
            </Box>
          </Stack>
        </Card>
        <Card><>
          <Box sx={{ padding: 1 }}>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }} aria-label="collapsible table" component={Paper}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={bookingList.length}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>

                    {bookingList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((list) => (
                      <>
                        <TableRow key={list._id} sx={{ '& > *': { borderBottom: 'unset' } }}>

                          <TableCell align="left">{list?.usersDetails?.userName ?? '--'}</TableCell>
                          <TableCell align="left">{list?.slotDate ? moment(list?.slotDate).format('DD MMM YYYY') : '--'}</TableCell>
                          <TableCell align="left">{list?.UTC_StartTime ? moment(list?.UTC_StartTime).format('hh a') : '--'} - {list?.UTC_EndTime ? moment(list?.UTC_EndTime).format('hh a') : '--'}</TableCell>
                          <TableCell align="left">{list?.expertDetails.expertName ?? '--'}</TableCell>
                          <TableCell align="left">
                            {list?.status === 'Success' ? <Chip label={list?.status === 'Success' ? (list.greetStatus === true ? 'Completed' : 'Pending') : list?.status} color={list.greetStatus === true ? "success" : 'warning'} variant='outlined' sx={{ width: '50%' }} /> : <></>}
                            {list?.status === 'Failed' || list?.status === 'Cancelled' ? <Chip label={list?.status} color="error" variant='outlined' sx={{ width: '50%' }} /> : <></>}
                            {list?.status === 'Rescheduled' || list?.status === 'Waiting' ? <Chip label={list?.status} color="warning" variant='outlined' sx={{ width: '50%' }} /> : <></>}

                          </TableCell>

                          <TableCell>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => {
                                if (rowClickId !== list._id) {
                                  setRowClickId(list._id)
                                } else {
                                  setOpen(!open)
                                }
                              }}
                            >
                              {open && rowClickId === list._id ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                          </TableCell>
                        </TableRow >
                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                            <Collapse in={open && rowClickId === list._id} timeout="auto" unmountOnExit>
                              <Table fullWidth>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Name To Greet</TableCell>
                                    <TableCell>Mobile Number</TableCell>
                                    <TableCell align="center" width={'300px'}>Greet Message</TableCell>
                                    <TableCell align="center">Upload Greet Content</TableCell>
                                    <TableCell align="left">Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell align='left'>{list?.name_greet ?? '--'}</TableCell>
                                    <TableCell align='left'>{list?.phone_no ?? '--'}</TableCell>
                                    <TableCell align='left'>{list?.message ?? '--'}</TableCell>
                                    <TableCell align='left'>
                                      <TextField
                                        fullWidth
                                        type="file"
                                        sx={{ marginLeft: 1 }}

                                        onChange={(event) => {
                                          console.log(event)
                                          if (event.target.files[0].type.startsWith('image/') || event.target.files[0].type.startsWith('video/') || event.target.files[0].type.startsWith('audio/')) {
                                            setGreetFile([{ id: list._id, file: event.target.files[0] }])
                                          } else {
                                            setGreetFile([{ id: list._id, file: '' }])
                                            event.target.value = '';
                                          }
                                        }
                                        }
                                      />
                                    </TableCell>
                                    <TableCell align='left'>
                                      <Button
                                        startIcon={<Send />}
                                        sx={{
                                          color: "white",
                                          padding: "10%",
                                          "&:hover": {
                                            backgroundColor: "button.theme"
                                          },
                                          bgcolor: "button.theme",

                                        }}
                                        disabled={list?.greetStatus}
                                        onClick={() => {
                                          sendUserMessage(list._id, list?.phone_no, list?.message)
                                        }}>
                                        {'Send'}
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </Collapse >
                          </TableCell>
                        </TableRow>
                      </>

                    ))}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {bookingList && bookingList.length === 0 && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph color={'red'}>
                              {isLoading ? 'Loading .....' : 'No Data Found'}
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={bookingList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box></>

        </Card>
      </Container >
      <ToastContainer />

    </>
  );
}
